import React from 'react';
import Ticker from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/ticker';
import usePermissionsChecker from 'helpers/hooks/usePermissionsChecker';
import { formatCustomerGroup } from '@loomstateorg/shared-frontend/helpers/formatter';

interface Props {
  data: any;
  customerGroup: any;
}

const TickerTastic: React.FC<Props> = ({ data, customerGroup }) => {
  const { getFields, checkItemPermission, filterByTags } = usePermissionsChecker();

  const dataSource = data?.data?.dataSource;

  const tickers = filterByTags(dataSource?.fields?.components ?? [], customerGroup) ?? [];

  if (!tickers?.length) return <></>;

  return (
    <>
      {tickers.map((item: any, index: number) => {
        if (!checkItemPermission(item, customerGroup)) return null;

        const fields = getFields(item);
        const firstText = fields?.firstText;
        const textColor = fields?.textColor;
        const repetitionFactor = fields?.repetitionFactor;
        const backgroundColor = fields?.backgroundColor;
        const heightBanner = fields?.heightBanner;

        if (!firstText) return null; // Skip if there's no data to show

        return (
          <Ticker
            key={item?.sys?.id || index}
            firstText={firstText}
            textColor={textColor}
            repetitionFactor={repetitionFactor}
            backgroundColor={backgroundColor}
            heightBanner={heightBanner}
          />
        );
      })}
    </>
  );
};

export default TickerTastic;
